import React, { useCallback, useMemo, useState } from "react";
import GalleryProduct from "./gallery-product";
import LightboxModal from "./lightbox-modal";
import classNames from "classnames";
import { eventInternalLinkClick } from "../utility/datalayer";

const GalleryModal = ({
  allSlidesData,
  badge,
  enhanced,
  labelManagerLabels,
  showZoom,
  zoomIdx,
  closeZoom,
  pagePath,
}) => {
  const [modalTab, setModalTab] = useState("all");
  const modalSlides = useMemo(() => {
    switch (modalTab) {
      case "all":
        return allSlidesData.filter(Boolean);
      case "video":
        return allSlidesData.filter((item) => item?.youtubeId).filter(Boolean);
      case "360":
        return allSlidesData.filter((item) => item?.url360).filter(Boolean);
      case "dimensions":
        return allSlidesData.filter((item) => !!item?.dimensions).filter(Boolean);
      default:
        return allSlidesData.filter(Boolean);
    }
  }, [allSlidesData, modalTab]);

  const onClickModalTabs = useCallback(
    (name) => {
      eventInternalLinkClick({
        click_element: "pdp_modal_tabs",
        link_text: name,
        slug: pagePath,
      });
    },
    [pagePath]
  );

  return (
    <LightboxModal
      show={zoomIdx >= 0}
      onHide={closeZoom}
      noCloseSelector=".lightbox-modal, #onetrust-pc-sdk"
    >
      <GalleryProduct
        slides={modalSlides}
        badge={badge}
        enhanced={enhanced}
        labelManagerLabels={labelManagerLabels}
        showZoom={showZoom}
        zoomIdx={zoomIdx}
        modalTab={modalTab}
        isModalGallery
      >
        {/* Tabs */}
        <div className="slider-tabs">
          <div className="slider-tabs__buttons">
            <button
              className={classNames(
                "slider-tabs__button",
                modalTab === "all" && "slider-tabs__button--active"
              )}
              onClick={(e) => {
                setModalTab("all");
                onClickModalTabs(labelManagerLabels.galleryAll);
              }}
            >
              {labelManagerLabels.galleryAll}
            </button>
            {allSlidesData?.find((slide) => slide?.dimensions) && (
              <button
                className={classNames(
                  "slider-tabs__button",
                  modalTab === "dimensions" && "slider-tabs__button--active"
                )}
                onClick={(e) => {
                  setModalTab("dimensions");
                  onClickModalTabs(labelManagerLabels.galleryDimensions);
                }}
              >
                {labelManagerLabels.galleryDimensions}
              </button>
            )}
            {allSlidesData?.find((slide) => slide?.youtubeId) && (
              <button
                className={classNames(
                  "slider-tabs__button",
                  modalTab === "video" && "slider-tabs__button--active"
                )}
                onClick={(e) => {
                  setModalTab("video");
                  onClickModalTabs(labelManagerLabels.galleryVideo);
                }}
              >
                {labelManagerLabels.galleryVideo}
              </button>
            )}
            {allSlidesData?.find((slide) => slide?.url360) && (
              <button
                className={classNames(
                  "slider-tabs__button",
                  modalTab === "360" && "slider-tabs__button--active"
                )}
                onClick={(e) => {
                  setModalTab("360");
                  onClickModalTabs(labelManagerLabels.gallery360);
                }}
              >
                {labelManagerLabels.gallery360}
              </button>
            )}
          </div>
        </div>
      </GalleryProduct>
    </LightboxModal>
  );
};

export default GalleryModal;
